import { render } from "./UiDbSubscription.vue?vue&type=template&id=48387d71"
import script from "./UiDbSubscription.vue?vue&type=script&lang=js"
export * from "./UiDbSubscription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__